import request from '@/utils/request'

// 获取所有的版本apk列表
export function getApkList(params) {
  return request({
    url: '/message/appversioninfo/page',
    method: 'get',
    params: params
  })
}

// 保存apk信息
export function saveOrUpdateApk(data) {
  return request({
    url: '/message/appversioninfo/save',
    method: 'post',
    data
  })
}
//删除apk信息
export function deleteApk(data) {
  return request({
    url: `/message/appversioninfo/delete/${data}`,
    method: 'post',
    data:{}
  })
}

//业务端APP版本管理-列表
export function appVersionList(params) {
  return request({
    url: `/admin/sysAppVersions/page`,
    method: 'get',
    params,
  })
}

//业务端APP版本管理-列表
export function appVersionAdd(data) {
  return request({
    url: `/admin/sysAppVersions`,
    method: 'post',
    data,
  })
}

//业务端APP版本管理-列表
export function appVersionDel(id) {
  return request({
    url: `/admin/sysAppVersions/${id}`,
    method: 'delete',
    data:{},
  })
}